module.exports = __webpack_public_path__ + "img/zhangjiagang.e6afa9eb.png";